import React, { useEffect, useState } from 'react';
import axios from 'axios';

// Origin and Created by (issue #308) — shared by the Quotes and Sales Orders
// lists' Filters drawer and their optional columns. Values match
// services/documentOrigin.js: origin is staff/portal/converted, created_by is
// "user:<id>" or "entity:<id>".
export const ORIGIN_OPTIONS = [
  { value: 'staff', label: 'Staff' },
  { value: 'portal', label: 'Portal' },
  { value: 'converted', label: 'Converted from Quote' },
];

const FIELD_LABEL_STYLE = { fontSize: 12, color: '#5a6b85' };
const FIELD_INPUT_STYLE = { padding: '6px 10px', borderRadius: 6, border: '1px solid #bfc8d6', fontSize: 14, width: '100%' };

// Everyone who has created one of these documents, for the Created by
// filter — `endpoint` is the list's own /creators route.
export function useDocumentCreators(endpoint) {
  const [creators, setCreators] = useState([]);
  useEffect(() => {
    axios.get(endpoint)
      .then((res) => setCreators(res.data.data || []))
      .catch(() => setCreators([]));
  }, [endpoint]);
  return creators;
}

// `origins` narrows the Origin choices to the ones this document can have.
function OriginFilterFields({ draft, setDraftField, creators, origins = ORIGIN_OPTIONS }) {
  return (
    <>
      <div style={{ marginTop: 14 }}>
        <label style={FIELD_LABEL_STYLE}>Origin</label><br />
        <select className="styled-input" value={draft.origin || ''} onChange={(e) => setDraftField('origin', e.target.value)} style={FIELD_INPUT_STYLE}>
          <option value="">All origins</option>
          {origins.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
      </div>
      <div style={{ marginTop: 14 }}>
        <label style={FIELD_LABEL_STYLE}>Created by</label><br />
        <select className="styled-input" value={draft.created_by || ''} onChange={(e) => setDraftField('created_by', e.target.value)} style={FIELD_INPUT_STYLE}>
          <option value="">Anyone</option>
          {creators.map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}
        </select>
      </div>
    </>
  );
}

export default OriginFilterFields;
